import React from 'react';
import SkeletonLoader from '@/components/shared/skeleton-loader/SkeletonLoader';
import GamesSkeletonLoader from '@/components/shared/skeleton-loader/GamesSkeletonLoader';

const GamesByProviderSkeletonLoader = () => {
  return (
    <div className="mx-auto md:max-w-[1400px] mt-16">
      <SkeletonLoader className="w-[50%] h-[36px] mb-8 ml-8" />
      <GamesSkeletonLoader />
    </div>
  );
};

export default GamesByProviderSkeletonLoader;
